// extracted by mini-css-extract-plugin
module.exports = {"app__header":"Q_dq","app__footer":"Q_Z","app__flex_row":"Q_dr","app__content__list":"Q_ds"};